function ImpactCard({ icon, title }) {
  return (
    <div className="impact-card text-center h-100">
      <div className="impact-icon mb-3  fs-1">
        {icon}
      </div>
      <h6 className="fw-semibold">{title}</h6>
    </div>
  );
}

export default ImpactCard;
